var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    {
      attrs: { expand: "" },
      model: {
        value: _vm.panel,
        callback: function($$v) {
          _vm.panel = $$v
        },
        expression: "panel"
      }
    },
    [
      _c(
        "v-expansion-panel-content",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("div", [_vm._v(_vm._s(_vm.$t("chatRealTime")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-md": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-right",
                      attrs: { xs12: "", "offset-sm6": "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loadingExportData,
                            disabled: _vm.loadingExportData,
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.download()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("exportInCsv")) +
                              "\n            "
                          ),
                          _c(
                            "v-icon",
                            { attrs: { color: "primary", right: "" } },
                            [_vm._v("file_download")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-3" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$tc("chats", 2, {
                                                      count: ""
                                                    })
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "primary--text display-1 text-xs-center",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.chatsOK) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-3" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$tc("messages", 2, {
                                                      count: ""
                                                    })
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "primary--text display-1 text-xs-center",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.nbMessages) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-3" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t(
                                                      "totalDurationOfChats"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "primary--text display-1 text-xs-center",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.totalDurationFormatted
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-3" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t(
                                                      "averageDurationOfOneChat"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "primary--text display-1 text-xs-center",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.averageDurationFormatted
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mb-3",
                          attrs: { height: _vm.heightOfJauge }
                        },
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c("highcharts", {
                                attrs: { options: _vm.chatsMissed }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mb-3",
                          attrs: { height: _vm.heightOfJauge }
                        },
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c("highcharts", {
                                attrs: { options: _vm.chatsByAgentFilter }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mb-3",
                          attrs: { height: _vm.heightOfJauge }
                        },
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c("highcharts", {
                                attrs: { options: _vm.chatsAverageResponse }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mb-3",
                          attrs: { height: _vm.heightOfJauge }
                        },
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c("highcharts", {
                                attrs: { options: _vm.chatsFirstResponse }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mb-3",
                          attrs: { height: _vm.heightOfJauge }
                        },
                        [
                          _vm.loading
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            : _c("highcharts", {
                                attrs: { options: _vm.chatsCloseTime }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _vm.histoready
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.getChats()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("hideChat")) +
                              "\n          "
                          ),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("visibility_off")
                          ])
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.getChats()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("showChat")) +
                              "\n          "
                          ),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("visibility")
                          ])
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _vm.histoready
                ? _c("wz-histo-chats", {
                    attrs: {
                      params: _vm.params,
                      numChatsTotal: String(_vm.chatsOK)
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel-content",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("div", [_vm._v("Messaging")])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-md": "" } },
            [_c("v-layout", { attrs: { row: "", wrap: "" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5527872b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5527872b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Chats.vue
// module id = null
// module chunks = 